import React, { useEffect, useRef, useState } from "react";
import {
  Paper,
  ToggleButtonGroup,
  ToggleButton,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Slider,
  Typography,
  Divider,
  checkboxClasses,
  styled,
} from "@mui/material";
// import "./FilterAsbestos.css";
import { useTranslation } from "react-i18next";

const CustomSlider = styled(Slider)(({ theme }) => ({
  color: "var(--color-primary)",
  height: 3,
  padding: "13px 0",
  "& .MuiSlider-thumb": {
    height: 27,
    width: 27,
    backgroundColor: "#fff",
    border: "1px solid currentColor",
    "&:hover": {
      boxShadow: "0 0 0 8px rgba(58, 133, 137, 0.16)",
    },
    "& .airbnb-bar": {
      height: 9,
      width: 1,
      backgroundColor: "currentColor",
      marginLeft: 1,
      marginRight: 1,
    },
  },
  "& .MuiSlider-track": {
    height: 3,
  },
  "& .MuiSlider-rail": {
    color: "var(--color-primary-light-50)",
    opacity: 1,
    height: 3,
    ...theme.applyStyles("dark", {
      color: "#bfbfbf",
      opacity: undefined,
    }),
  },
}));
const FilterAsbestosInventory = ({ callback, filters }) => {
  // const [filters, setFilters] = useState([
  //   { key: 'Uso', values: [
  //     "Agrícola",
  //     "Oficinas",
  //     "Retail",
  //     "No consta",
  //     "Servicios Públicos",
  //     "Industrial",
  //     "Residencial"], operation: 'OR' },
  //    { key: 'Titular', values: ['Privado',"Público", "Municipal"], operation: 'OR' },
  //    { key: 'Nivel_ries', values: ['Alto',"Medio", "Leve", "Muy Alto"], operation: 'OR' },
  //    { key: 'potencial_comercial_solar_norm', values: [">=0"], operation: 'OR' }
  // ]
  // )
  const { t } = useTranslation("main");

  const default_use_colors = {
    Industrial: "#fc8d62",
    Agrícola: "#66c2a5",
    Retail: "#ffd92f",
    Oficinas: "#e5c494",
    "Servicios Públicos": "#a6d854",
    Residencial: "#e78ac3",
    Otros: "#8da0cb",
  };
  const handleTitularidadChange = (event, newTitularidad) => {
    if (newTitularidad !== null) {
      setTitularidad(newTitularidad);
      console.log("Titularidad seleccionada:", newTitularidad);
    }
  };
  const getFilterValue = (filters, key) => {
    return filters.filter((f) => f.key == key)[0];
  };

  const getTitularidadFromFilters = (filters) => {
    const f = getFilterValue(filters, "owner");
    let isPrivado = false;
    let isPublico = false;
    if (!f) {
      return "Todo";
    }
    console.log("Obteniendo valor  dee titularidad desde filtros", filters, f);
    if (f.values.includes("Privado")) {
      isPrivado = true;
    }
    if (f.values.includes("Público")) {
      isPublico = true;
    }
    if (isPublico && isPrivado) {
      return "Todo";
    } else if (isPublico) {
      return "Público";
    } else if (isPrivado) {
      return "Privado";
    } else {
      return "Todo";
    }
  };

  const getUsesFromFilters = (filters) => {
    const f = getFilterValue(filters, "current_use");
    console.log("Obteniendo usos de filtros", filters, f);
    let default_values = {
      Industrial: false,
      Agrícola: false,
      Retail: false,
      Oficinas: false,
      "Servicios Públicos": false,
      Residencial: false,
      Otros: false,
    };

    if (!f) {
      return {
        Industrial: true,
        Agrícola: true,
        Retail: true,
        Oficinas: true,
        "Servicios Públicos": true,
        Residencial: true,
        Otros: true,
      };
    }
    for (const key of f.values) {
      console.log("key", key);
      default_values[key] = true;
    }
    return default_values;
  };
  const getSusceptibilidadFromFilters = (filters) => {
    const f = getFilterValue(filters, "asbestos_susceptibility");
    console.log("Susceptibilidad filter value", f);
    if (!f) {
      return 0;
    }
    // if(f.values.includes("Muy Alto")){
    //   console.log("Susceptibilidad filter value - Muy alto")
    //   return 3
    // }else if (f.values.includes("Alto")){
    //   console.log("Susceptibilidad filter value - alto")
    //   return 2
    // }else if (f.values.includes("Medio")){
    //   console.log("Susceptibilidad filter value - Medio")
    //   return 1
    // }else if (f.values.includes("Leve")){
    //   console.log("Susceptibilidad filter value - Leve")
    //   return 0
    // }
    if (f.values.includes("Leve")) {
      return 0;
    } else if (f.values.includes("Medio")) {
      return 1;
    } else if (f.values.includes("Alto")) {
      return 2;
    } else if (f.values.includes("Muy Alto")) {
      return 3;
    }
  };

  const [hasMounted, setHasMounted] = useState(false); // Estado para controlar si es el primer renderizado
  const [titularidad, setTitularidad] = useState(
    getTitularidadFromFilters(filters)
  );
  const [susceptibilidad, setSusceptibilidad] = useState(
    getSusceptibilidadFromFilters(filters)
  );

  const [tipoUso, setTipoUso] = useState(getUsesFromFilters(filters));

  const lastExecuted = useRef(0); // Usamos `useRef` para almacenar el último tiempo de ejecución.
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  let timeOutCoste = null;
  const handleTipoUsoChange = (event) => {
    setTipoUso({
      ...tipoUso,
      [event.target.name]: event.target.checked,
    });
    console.log(
      "Tipo de uso seleccionado:",
      event.target.name,
      event.target.checked
    );
  };

  const handleSusceptibilidadChange = (event, newValue) => {
    setSusceptibilidad(newValue);
    console.log("Susceptibilidad de contener amianto:", newValue);
  };

  const executeCallback = () => {
    const now = Date.now();
    // Actualizamos el último tiempo de ejecución
    lastExecuted.current = now;

    // Lógica para calcular los filtros
    console.log("usoValues", tipoUso);

    const usoValues = Object.keys(tipoUso).filter((key) => tipoUso[key]);
    const titularValues = [];
    console.log("Calculando filtros", usoValues);

    if (titularidad === "Público") {
      titularValues.push("Municipal");
      titularValues.push("Público");
    } else if (titularidad === "Privado") {
      titularValues.push("Privado");
    } else {
      titularValues.push("Privado");
      titularValues.push("Municipal");
      titularValues.push("Público");
    }

    let riskValues = ["Leve", "Medio", "Alto", "Muy Alto"];
    riskValues = riskValues.slice(susceptibilidad, riskValues.length);

    let filter = [
      { key: "current_use", values: usoValues, operation: "OR" },
      { key: "owner", values: titularValues, operation: "OR" },
      // { key: "risk_final_value", values: riskValues, operation: "OR" },
    ];

    filter = filter.filter((e) => e.values.length > 0);
    console.log("Filtros a enviar", filter);

    callback(filter);
  };
  useEffect(() => {
    if (!hasMounted) {
      setHasMounted(true); // Marcar que ya se ha montado
      return;
    }
    const now = Date.now(); // Obtiene el timestamp actual en milisegundos.

    // Si ha pasado menos de 1 segundo desde la última ejecución, no se ejecuta el callback
    if (now - lastExecuted.current < 1000) {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }
      const newTimeout = setTimeout(() => {
        executeCallback();
      }, 1000);
      setDebounceTimeout(newTimeout);
      return;
    }
    executeCallback();
  }, [titularidad, tipoUso, callback]);

  // const handleCallback = ()=>{

  return (
    <Paper
      sx={{
        padding: "2rem",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        textAlign: "left",
        width: "100%",
      }}
    >
      {/* Filtro de Titularidad */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          width: "100%",
        }}
      >
        <Typography
          variant="h6"
          style={{
            height: "100%",
            paddingRight: "1rem",
            paddingBottom: "0.5rem",
          }}
        >
          {t("titularidad")}
        </Typography>
        <ToggleButtonGroup
          value={titularidad}
          exclusive
          onChange={handleTitularidadChange}
          aria-label="Filtro de Titularidad"
          sx={{ marginBottom: "1rem" }}
        >
          <ToggleButton value="Todo">{t("titularidad-todo")}</ToggleButton>
          <ToggleButton value="Público">
            {t("titularidad-publico")}
          </ToggleButton>
          <ToggleButton value="Privado">
            {t("titularidad-privado")}
          </ToggleButton>
        </ToggleButtonGroup>
      </div>

      <Divider
        style={{
          borderColor: "var(--color-primary-light-80)",
          margin: "1rem",
          marginBottom: "1.5rem",
        }}
        variant="middle"
      />

      {/* Filtro de Tipo de Uso */}
      <Typography variant="h6">{t("uso_del_edificio")}</Typography>
      <FormControl component="fieldset" sx={{ marginBottom: "1rem" }}>
        <FormGroup row>
          {Object.keys(tipoUso).map((tipo) => (
            <FormControlLabel
              control={
                <Checkbox
                  sx={{
                    [`&, &.${checkboxClasses.checked}`]: {
                      color: Object.keys(default_use_colors).includes(tipo)
                        ? default_use_colors[tipo]
                        : "red",
                    },
                  }}
                  iconStyle={{
                    fill: Object.keys(default_use_colors).includes(tipo)
                      ? default_use_colors[tipo]
                      : "red",
                  }}
                  checked={tipoUso[tipo]}
                  onChange={handleTipoUsoChange}
                  name={tipo}
                />
              }
              label={t("uso_del_edificio_" + tipo)}
              key={tipo}
            />
          ))}
        </FormGroup>
      </FormControl>

      {/* <Divider
        style={{
          borderColor: "var(--color-primary-light-80)",
          margin: "1rem",
          marginBottom: "1.5rem",
        }}
        variant="middle"
      />
      <Typography variant="h6">Susceptibilidad de Contener Amianto</Typography>
      <CustomSlider
        value={susceptibilidad}
        min={0}
        max={3}
        step={1}
        marks={susceptibilidadMarks}
        onChange={handleSusceptibilidadChange}
        valueLabelDisplay="auto"
        sx={{ marginBottom: "2rem" }}
      /> */}
      <Divider
        style={{
          borderColor: "var(--color-primary-light-80)",
          margin: "1rem",
          marginBottom: "1.5rem",
        }}
        variant="middle"
      />
    </Paper>
  );
};

export { FilterAsbestosInventory };
